import React from 'react';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';

const DashboardLayout = ({ children, userRole, userName }) => {
  const location = useLocation();
  
  // Extract role from URL if not provided
  const extractedRole = userRole || location.pathname.split('/')[1];
  
  return (
    <div className="flex min-h-screen flex-col bg-slate-100">
      <div className="h-[72px]"></div>
      
      <div className="flex flex-1">
        <Sidebar userRole={extractedRole} />
        
        <div className="flex min-h-[calc(100vh-72px)] w-full flex-col lg:ml-72">
          <header className="sticky top-[72px] z-10 flex items-center justify-between border-b border-slate-200 bg-white/92 p-4 shadow-sm backdrop-blur md:px-6">
            <h1 className="text-xl font-semibold text-secondary truncate">
              Selamat Datang, {userName || 'User'}
            </h1>
            <div className="flex items-center space-x-4">
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary font-semibold text-white">
                {userName ? userName.charAt(0).toUpperCase() : 'U'}
              </div>
            </div>
          </header>
          
          <main className="flex-grow overflow-x-hidden p-4 md:p-6">
            <div className="max-w-full">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout; 
